import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const teamcity = defineConnector({
  identifier: "teamcity",
  name: "TeamCity",
  tagLine: "JetBrains CI/CD server",
  logo,
  protocol: "http",
  tags: ["engineering"],
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Get your TeamCity access token",
      items: [
        {
          kind: "markdown",
          content:
            "In TeamCity, click your profile icon in the top right, go to **Access Tokens**, and create a new token with the permissions you need.",
        },
      ],
    },
    {
      title: "Enter your TeamCity details",
      items: [
        {
          kind: "url",
          label: "TeamCity server URL",
          required: true,
          placeholder: "https://teamcity.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your TeamCity server.",
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/app/rest/server`,
  },
});
